import { useCallback, useState } from 'react';

// Tour state for a logged-in page. The tour only opens when the user asks for it
// (the header Tour button calls `start`); it never opens on its own.
export function usePageTour() {
  const [touring, setTouring] = useState(false);
  const start = useCallback(() => setTouring(true), []);
  const end = useCallback(() => setTouring(false), []);
  return { touring, start, end };
}
